import SinglePost from 'components/Post/SinglePost';
import TfHighlights from 'components/Tools/BlogNameGenerator/TfHighlights';
import Footer from '../General/Footer';
import Head from 'components/Header/Head';
import Header from 'components/Header/Header';
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_VOTES_SMILES } from 'helpers/graphql/singlePost';

export default function BlogPost({ post }) {
  let { author, title, thumb, faq, excerpt, seo, permlink, tags } = post;

  const [comments, setComments] = useState(post.comments);
  const [smiles, setSmiles] = useState(post.smiles);
  const [totalSmiles, setTotalSmiles] = useState(post.totalSmiles);

  function onCompleted(data) {
    if (data && data.post) {
      setComments(data.post.comments);
      setSmiles(data.post.smiles);
      setTotalSmiles(data.post.totalSmiles);
    }
  }

  // The static site is not refreshed every time there is a comment or vote. Instead, we update comments & votes client-side
  useQuery(GET_VOTES_SMILES, {
    variables: { author: author.username, permlink },
    onCompleted,
    ssr: false,
    fetchPolicy: 'no-cache',
  });

  const generatedOgImage = `https://og.travelfeed.com/api/post?title=${encodeURIComponent(
    title,
  )}&image=${encodeURIComponent(thumb ? thumb.url : undefined)}`;

  const thePost = {
    ...post,
    comments,
    smiles,
    totalSmiles,
    allImgDetails: post.images,
  };

  return (
    <>
      <Header
        active="post"
        socialShare={{
          author: author.username,
          permlink,
          tags,
          title,
          thumbnail: thumb ? thumb.url : undefined,
        }}
      />
      <Head
        seo={seo}
        shorttitle={title}
        image={generatedOgImage}
        description={excerpt}
        post={post}
        type="article"
        faq={faq}
        isBlogPost
      />
      <div className="tw-pt-20" />
      <SinglePost post={thePost} isSimpleCover />
      {/* Wave must match the tf-paper article background above it */}
      <TfHighlights topFill="tw-fill-[#FAF8F1] dark:tw-fill-[#0E1A16]" />
      <div className="tw-pt-8" />
      <Footer isNoSpace />
    </>
  );
}
